<template>
    <v-container fluid class="align-center column" style="height: auto">
        <div class="path align-center">
            <div class="row screen-width" style="height: 24px; gap: 24px">
                <HomeOutline :size="24"></HomeOutline>
                <ChevronRight :size="24"></ChevronRight>
                <p>문제해결</p>
                <ChevronRight :size="24"></ChevronRight>
                <p>{{ $route.query.category }}</p>
                <ChevronRight :size="24"></ChevronRight>
                <p>{{ subCategory?.sub_category ?? "전체" }}</p>
            </div>
        </div>

        <div id="product-select" class="column screen-width">
            <p style="font-size: 32px; font-weight: bold">
                {{ category }}
            </p>
            <p style="font-size: 20px">• 제품 분류를 선택해주세요</p>
            <div class="row align-space-between" style="width: 100%">
                <div
                    id="product-list"
                    style="
                        display: flex;
                        align-content: center;
                        flex-wrap: wrap;
                    "
                >
                    <text-button
                        :textSize="14"
                        :buttonName="'전체'"
                        :buttonStyle="{
                            border: '1px solid #CECECE',
                            background: 'white',
                        }"
                        @click="selectSubCategory(0)"
                        :clicked="0 == selectedSubCategory"
                    ></text-button>
                    <text-button
                        v-for="(category, index) in product_category"
                        :key="index"
                        :textSize="14"
                        :buttonName="category.sub_category"
                        :buttonStyle="{
                            border: '1px solid #CECECE',
                            background: 'white',
                        }"
                        @click="selectSubCategory(index + 1)"
                        :clicked="index + 1 == selectedSubCategory"
                    ></text-button>
                </div>
                <text-button
                    :textSize="16"
                    :buttonName="'다른제품 선택'"
                    :buttonStyle="{ border: '1px solid #000000' }"
                    @click="showOtherCategories = !showOtherCategories"
                ></text-button>
            </div>
        </div>
        <div
            v-if="showOtherCategories"
            id="product-list"
            class="screen-width"
            style="display: flex; align-content: center; flex-wrap: wrap"
        >
            <v-slide-group show-arrows>
                <v-slide-group-item
                    v-for="(categoryInfo, index) in otherCategory"
                    :key="index"
                    style="margin-right: 8px"
                >
                    <router-link
                        class="align-center"
                        :class="{
                            selected_router: categoryInfo.content == category,
                        }"
                        style="
                            background: white;
                            padding: 8px;
                            border-radius: 10px;
                            border: 1px lightgray solid;
                            margin: 0px 8px;
                        "
                        :to="categoryInfo.path"
                    >
                        <image-text-button
                            :imageSrc="categoryInfo.src"
                            :textContent="categoryInfo.content"
                            :textStyle="{
                                fontSize: '16px',
                                color: 'black',
                            }"
                        />
                    </router-link>
                </v-slide-group-item>
            </v-slide-group>
        </div>

        <div id="keyword-select" class="column screen-width">
            <p style="font-size: 28px; font-weight: bold">많이하는 질문</p>
            <p style="font-size: 20px">
                • 아래의 키워드를 선택하시면 관련 정보를 확인할 수 있습니다.
            </p>
            <div class="row align-space-between" style="width: 100%">
                <div
                    id="keyword-list"
                    style="display: flex; align-content: center"
                >
                    <text-button
                        v-for="(keyword, index) in keywordMap[category]"
                        :key="index"
                        :textSize="14"
                        :buttonName="keyword"
                        :buttonStyle="{
                            border: '1px solid #CECECE',
                            background: 'white',
                        }"
                        @click="selectKeyword(index)"
                        :clicked="keyword == selectedKeyword"
                    ></text-button>
                </div>
            </div>
        </div>

        <div id="search" class="column screen-width">
            <p style="font-size: 28px; font-weight: bold">
                궁금한 사항을 입력하세요
            </p>
            <search-bar :size="100" v-on:onSearch="searchSolution"></search-bar>
            <div class="row" style="gap: 32px">
                <a class="search-tag"> #플로터 기능 </a>
                <a class="search-tag"> #플로터 기능 </a>
                <a class="search-tag"> #플로터 기능 </a>
                <a class="search-tag"> #플로터 기능 </a>
            </div>
        </div>

        <div id="faq" class="screen-width">
            <div class="row" style="gap: 14px; margin-bottom: 16px">
                <p style="font-size: 28px; font-weight: bold; color: #00a7e7">
                    {{ category }}
                </p>
                <p style="font-size: 28px; font-weight: bold">FAQ 해결방법</p>
            </div>
            <div id="faq-list">
                <post-list-item
                    v-for="faq in faqList"
                    :key="faq"
                    :title="faq.question"
                    :category="'분류'"
                    :date="faq.createdAt"
                    :id="String(faq.id)"
                ></post-list-item>
            </div>
        </div>

        <div id="data" class="screen-width">
            <div class="row align-space-between" style="margin-bottom: 16px">
                <div class="row" style="gap: 14px">
                    <p
                        style="
                            font-size: 28px;
                            font-weight: bold;
                            color: #00a7e7;
                        "
                    >
                        {{ category }}
                    </p>
                    <p style="font-size: 28px; font-weight: bold">검색 자료</p>
                </div>
                <v-select
                    v-model="select"
                    :items="items"
                    base-color="white"
                    bg-color="white"
                    color="white"
                    item-title="title"
                    item-value="value"
                    item-color="gray"
                    :max-width="120"
                    width="40"
                    return-object
                    :hide-details="true"
                    @update:modelValue="getSolutionList"
                ></v-select>
            </div>
            <div id="data-list">
                <post-list-item
                    v-for="solution in solutionList"
                    :key="solution"
                    :title="solution.title"
                    :category="solution.keyword[categoryNumber]?.join(', ')"
                    :date="solution.createdAt"
                    :id="String(solution.id)"
                ></post-list-item>
            </div>
            <custom-pagination
                style="margin-top: 32px"
                :currentPage="currentPage"
                :totalPages="totalPages"
                v-on:update="loadPageData"
            ></custom-pagination>
        </div>
    </v-container>
</template>

<script>
import { ref, onMounted, computed, onUpdated } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import HomeOutline from "vue-material-design-icons/HomeOutline.vue";
import ChevronRight from "vue-material-design-icons/ChevronRight.vue";
import TextButton from "@/components/TextButton.vue";
import SearchBar from "@/components/SearchBar.vue";
import PostListItem from "@/components/PostListItem.vue";
import CustomPagination from "@/components/CustomPagination.vue";
import ImageTextButton from "@/components/ImageTextButton.vue";

export default {
    name: "problem-layout",
    components: {
        HomeOutline,
        ChevronRight,
        TextButton,
        SearchBar,
        PostListItem,
        CustomPagination,
        ImageTextButton,
    },
    setup() {
        const route = useRoute(); // 현재 라우트 객체를 반응형 참조로 가져옵니다.
        const store = useStore();
        const select = ref({ title: "날짜순", value: "createdAt" });
        const showOtherCategories = ref(false);
        const items = [
            { title: "날짜순", value: "createdAt" },
            { title: "조회순", value: "viewCount" },
        ];
        const category = computed(() => {
            return route.query.category;
        }); // route.query.name에 접근하는 computed 속성을 생성합니다.
        const subCategory = ref({
            sub_category: "",
        });
        const categoryNumber = ref(0);

        const categoryMap = {
            GPS플로터: 0,
            레이더: 1,
            "무선/통신장비": 2,
            "항해 안전장비": 3,
            "항해 조타장비": 4,
            "해상용 안테나/헤딩센서": 5,
            "선박용 인산철배터리": 6,
            "선박용 전기관련 제품": 7,
            "부품 및 액세서리": 8,
        };

        const otherCategory = ref([
            {
                src: require("@/assets/img/gpsplotter.avif"),
                content: "GPS플로터",
                path: {
                    path: "/problem",
                    query: { category: "GPS플로터" },
                },
            },
            {
                src: require("@/assets/img/radar.avif"),
                content: "레이더",
                path: {
                    path: "/problem",
                    query: { category: "레이더" },
                },
            },
            {
                src: require("@/assets/img/wirelessconnect.avif"),
                content: "무선/통신장비",
                path: {
                    path: "/problem",
                    query: { category: "무선/통신장비" },
                },
            },
            {
                src: require("@/assets/img/safety.avif"),
                content: "항해 안전장비",
                path: {
                    path: "/problem",
                    query: { category: "항해 안전장비" },
                },
            },
            {
                src: require("@/assets/img/navigation.avif"),
                content: "항해 조타장비",
                path: {
                    path: "/problem",
                    query: { category: "항해 조타장비" },
                },
            },

            {
                src: require("@/assets/img/antena.avif"),
                content: "해상용 안테나/헤딩센서",
                path: {
                    path: "/problem",
                    query: { category: "해상용 안테나/헤딩센서" },
                },
            },
            {
                src: require("@/assets/img/battery.avif"),
                content: "선박용 인산철배터리",
                path: {
                    path: "/problem",
                    query: { category: "선박용 인산철배터리" },
                },
            },
            {
                src: require("@/assets/img/electronic.avif"),
                content: "선박용 전기관련 제품",
                path: {
                    path: "/problem",
                    query: { category: "선박용 전기관련 제품" },
                },
            },
            {
                src: require("@/assets/img/accessory.avif"),
                content: "부품 및 액세서리",
                path: {
                    path: "/problem",
                    query: { category: "부품 및 액세서리" },
                },
            },
            {
                src: require("@/assets/img/discontinued.avif"),
                content: "단종제품",
                path: {
                    name: "Problem",
                    params: { category: "단종제품" },
                },
            },
        ]);

        const keywordMap = {
            GPS플로터: [
                "전원",
                "재부팅,사용중멈춤",
                "지도,해도",
                "네트워트,연동",
                "수심,수온",
                "포인트원",
                "헤딩선,코스선",
                "액정,화면,밝기",
                "목적지,항적",
                "중지됨",
                "초기화",
                "기타",
            ],
            레이더: [
                "전원",
                "레이더신호없음",
                "물표 안 찍힘",
                "네트워트,연동",
                "무선국허가",
                "기타",
            ],
            "무선/통신장비": [
                "전원",
                "GPS연동",
                "송신,수신안됨",
                "EPIRB자동발사",
                "EPIRB배터리교체",
                "EPIRB수압이탈기 교체",
                "코딩",
                "무선국허가",
                "AIS",
                "기타",
            ],
            "항해 안전장비": ["공급전압", "배율", "리모컨", "기타"],
            "항해 조타장비": ["선외기", "설치", "기타"],
            "해상용 안테나/헤딩센서": ["설치", "GPS안테나 연동", "기타"],
            "선박용 인산철배터리": [
                "배터리 용량",
                "셀등급",
                "크기,무게",
                "기타",
            ],
            "선박용 전기관련 제품": [],
            "부품 및 액세서리": [
                "송수파기 설치",
                "NMEA2000 전원",
                "송수파기 잡음",
                "따개비방지장비",
                "기타",
            ],
        };

        const product_category = computed(() => {
            // ✅ 서버에서 이미 '전체' 서브카테고리를 내려주는 경우가 있어,
            // 프론트에서 별도의 '전체' 버튼과 중복되지 않도록 제거
            return (store.getters.getSubCategoryList ?? []).filter(
                (c) => c?.sub_category !== "전체"
            );
        });

        const selectedSubCategory = ref(0);

        const selectedModel = ref(0);

        const selectedKeyword = ref("");

        const searchKeyword = ref("");

        const selectSubCategory = (index) => {
            selectedSubCategory.value = index;

            if (index == 0) {
                subCategory.value = null;
            } else {
                subCategory.value = product_category.value[index - 1];
            }

            selectedKeyword.value = null;
            currentPage.value = 1;
            getSolutionList();
        };

        const selectKeyword = (index) => {
            if (selectedKeyword.value == keywordMap[category.value][index]) {
                selectedKeyword.value = null;
            } else {
                selectedKeyword.value = keywordMap[category.value][index];
            }
            currentPage.value = 1;
            getSolutionList();
        };

        const currentPage = ref(1);
        const totalPages = computed(() => {
            return Math.ceil(store.getters.getSolutionTotalCount / 10);
        });

        const loadPageData = (page) => {
            currentPage.value = page;
            getSolutionList();
        };

        const faqList = computed(() => {
            return store.getters.getFaqList;
        });

        const solutionList = computed(() => {
            return store.getters.getSolutionList;
        });

        const getSolutionList = () => {
            const keyword = selectedKeyword.value
                ? `${categoryMap[category.value]}:${selectedKeyword.value}`
                : null;
            try {
                store.dispatch("getSolutionList", {
                    categoryId: subCategory.value?.id,
                    mainCategoryId: categoryMap[category.value],
                    take: 10,
                    page: currentPage.value,
                    keyword: keyword,
                    search: searchKeyword.value,
                    order: select.value.value,
                });
            } catch (err) {
                console.log(err);
            }
        };

        const searchSolution = (search) => {
            searchKeyword.value = search;
            currentPage.value = 1;
            getSolutionList();
        };

        onUpdated(async () => {
            selectedSubCategory.value = 0;
            categoryNumber.value = categoryMap[category.value];
            await store.dispatch(
                "getSubCategorySolutionList",
                categoryMap[category.value]
            );
            subCategory.value = null;
            searchKeyword.value = null;
            getSolutionList();
        });

        onMounted(async () => {
            categoryNumber.value = categoryMap[category.value];

            await store.dispatch(
                "getSubCategorySolutionList",
                categoryMap[category.value]
            );
            subCategory.value = null;

            getSolutionList();
        });

        return {
            product_category,
            selectSubCategory,
            selectedSubCategory,
            selectedKeyword,
            selectKeyword,
            currentPage,
            totalPages,
            loadPageData,
            category,
            faqList,
            subCategory,
            selectedModel,
            solutionList,
            searchSolution,
            keywordMap,
            items,
            select,
            getSolutionList,
            showOtherCategories,
            otherCategory,
            categoryNumber,
        };
    },
};
</script>

<style scoped>
/* 화면 너비가 601px에서 900px 사이인 경우 */

@media (min-height: 601px) and (max-height: 850px) {
    .sensor-title {
        font-size: 0.675rem;
        padding: 2px 15px;
    }
    .sensor-value {
        padding: 5px 15px;
        font-size: 1rem;
    }
}

#product-select {
    padding: 40px 0px;
    gap: 24px;
}

#product-list {
    width: 85%;
    height: auto;
    background: #f4f4f4;
    border-radius: 10px;
    border: 1px solid #d9d9d9;
    padding: 30px;
    gap: 16px;
}

#model-list {
    width: 100%;
    height: auto;
    padding: 0px 30px;
    gap: 16px;
    flex-wrap: wrap;
    /* 이 설정이 요소들을 자동으로 줄 바꿈하게 합니다 */
}

#keyword-select {
    padding: 40px 0px;
    gap: 24px;
}

#keyword-list {
    width: 100%;
    height: auto;
    background: #f4f4f4;
    border-radius: 10px;
    border: 1px solid #d9d9d9;
    padding: 30px;
    gap: 16px;
    flex-wrap: wrap;
    /* 이 설정이 요소들을 자동으로 줄 바꿈하게 합니다 */
}

#search {
    padding: 32px 0px;
    gap: 24px;
}

#faq {
    padding: 32px 0px;
}

#faq-list {
    width: 100%;
    border-top: 1px solid black;
}

#data {
    padding: 32px 0px;
}

#data-list {
    width: 100%;
    border-top: 1px solid black;
}

.selected {
    color: #00a7e7;
    font-weight: bold;
}
.selected_router {
    border: 1px #00a7e7 solid !important;
}
</style>
